<template>
  <div
    class="product-container"
    :class="[
      configs.class,
      isSmallerDevices ? 'row-cols-1' : isLargerDevices ? 'row-cols-2' : isLaptops ? 'row-cols-3' : configs.layout,
    ]"
  >
    <template v-for="product in products">
      <div :class="['col']" :key="product.id">
        <ProductCard :product="product" />
      </div>
    </template>
    <div class="loadMore" @click="loadMore()">Xem tiếp sản phẩm</div>
  </div>
</template>

<script>
import ProductCard from "./ProductCard.vue";
export default {
  props: {
    products: Array,
    configs: Object,
  },
  components: {
    ProductCard,
  },
  methods: {
    loadMore() {
      this.$emit("loadMore");
    },
  },
  computed: {
    isSmallerDevices() {
      return screen.width <= 480;
    },
    isLargerDevices() {
      return screen.width <= 769;
    },
    isLaptops() {
      return screen.width <= 1279;
    },
    isDesktop() {
      return screen.width <= 1400;
    },
  },
};
</script>

<style scoped lang="scss">
.product-container {
  padding-bottom: 100px;
  position: relative;
  .loadMore {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    color: #000;
    font-weight: bold;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
    width: 200px;
  }
}
@media screen and (max-width: 1660px) and (min-width: 1279px) {
  .product-container {
    padding: 0 80px 60px 80px;
  }
}
@media screen and (max-width: 1279px) and (min-width: 769px) {
  .product-container {
    padding: 0 60px 60px 60px;
    margin-right: 0;
    margin-left: 0;
  }
}
@media screen and (max-width: 768px) and (min-width: 481px) {
  .product-container {
    padding: 0 40px 60px 40px;
  }
}
@media screen and (max-width: 480px) and (min-width: 0) {
}
</style>
